import { render, staticRenderFns } from "./InfoTopicContent.vue?vue&type=template&id=d8d78d20&scoped=true&"
import script from "./InfoTopicContent.vue?vue&type=script&lang=js&"
export * from "./InfoTopicContent.vue?vue&type=script&lang=js&"
import style0 from "./InfoTopicContent.vue?vue&type=style&index=0&id=d8d78d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d78d20",
  null
  
)

export default component.exports